import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'
import { TYPES } from '@md/users/constances'

const List = () => import('./views/List')

const ROUTE_NAME = 'profile:applications:dealer:'

const p = name => ROUTE_NAME + name

const LIST = p('list')

export function createRoutes(options) {
  return [
    route('dealer/list/', List, LIST, {
      meta: {
        label: 'APPLICATIONS_DEALER_LIST',
        accessConfig: accessPermission([TYPES.OPERATOR_DEALER], options),
      },
    }),
  ]
}
